import type { FC } from 'react'
import { Button } from 'ui'
import {
  changeLangTo,
  useNavbarLanguage,
} from '../../Login/Components/Navbar/Navbar'
import { BannerChrome } from '../BannerChrome/BannerChrome'
import { ModalChrome } from '../ModalChrome/ModalChrome'

export const PrivateNavbar: FC = () => {
  const navbarLanguage = useNavbarLanguage()

  return (
    <>
      <div className="box-content gap-6 flex h-8 py-8 px-10">
        <div className="grow" />
        <Button
          label={navbarLanguage}
          onClick={changeLangTo(navbarLanguage)}
          size="small"
          variant="tertiary"
        />
      </div>
      <BannerChrome />
      <ModalChrome />
    </>
  )
}
